import * as zod from 'zod';

import { Conditional } from '../../types';

export default zod.object({
  message: zod.string().optional(),
  condition: Conditional.nullable().default(null),
});
